import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { fetchMyOrders } from '../api/customer';
import { useCustomerAuth } from '../state/customerAuth';
import '../styles/account.css';

export function CustomerDashboardPage() {
  const { token, customer, isAuthenticated, booting, logout } = useCustomerAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!token) return;
    let c = false;
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const list = await fetchMyOrders(token);
        if (!c) setOrders(list);
      } catch (e) {
        if (!c) setErr(e instanceof Error ? e.message : 'Failed to load orders');
      } finally {
        if (!c) setLoading(false);
      }
    })();
    return () => {
      c = true;
    };
  }, [token]);

  if (booting) {
    return (
      <main className="accountDash accountDash--center">
        <p className="accountDash__muted">Loading…</p>
      </main>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/account" replace />;
  }

  return (
    <main className="accountDash">
      <div className="accountDash__inner">
        <header className="accountDash__head">
          <div>
            <h1 className="accountDash__title">My account</h1>
            <p className="accountDash__muted">
              Signed in as <strong>{customer?.email}</strong>
            </p>
          </div>
          <div className="accountDash__actions">
            <Link to="/shop" className="accountDash__btn accountDash__btn--ghost">
              Shop
            </Link>
            <Link to="/checkout" className="accountDash__btn accountDash__btn--ghost">
              Checkout
            </Link>
            <button type="button" className="accountDash__btn" onClick={() => logout()}>
              Log out
            </button>
          </div>
        </header>

        <section className="accountDash__card">
          <h2 className="accountDash__h2">Order history</h2>
          <p className="accountDash__muted accountDash__mb">
            Track status, totals, and line items for every order placed with this email.
          </p>

          {loading ? <p className="accountDash__muted">Loading orders…</p> : null}
          {err ? <p className="accountDash__err">{err}</p> : null}

          {!loading && !err && orders.length === 0 ? (
            <p className="accountDash__muted">No orders yet. When you check out with this email, they appear here.</p>
          ) : null}

          {orders.length > 0 ? (
            <div className="accountDash__tableWrap">
              <table className="accountDash__table">
                <thead>
                  <tr>
                    <th>Order</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Total</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {orders.map((o) => (
                    <tr key={o.id}>
                      <td>
                        <code>{o.number}</code>
                      </td>
                      <td>{o.placed_at || o.created_at || '—'}</td>
                      <td>
                        <span className="accountDash__pill">{o.status}</span>
                      </td>
                      <td>{o.total_formatted || `—`}</td>
                      <td>
                        <Link className="accountDash__link" to={`/account/orders/${o.id}`}>
                          Details
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </section>
      </div>
    </main>
  );
}
